import React, { useEffect, useRef } from "react";
import { Dropdown, Form, Image } from "react-bootstrap";
import buttonIcon from '../../../img/icons/hide-columns-icon.svg'
import { Tooltip } from "@material-ui/core";

const CustomToggle = React.forwardRef(({onClick}, ref) => (
  <Tooltip title={'Показать столбцы'}>
    <Image
      src={buttonIcon}
      style={{width: 24, height: 24, cursor: 'pointer'}}
      ref={ref}
      onClick={onClick}
    />
  </Tooltip>

))

const CustomItem = React.forwardRef(({onClick, name, checked}, ref) => {
  return (
    <div className="d-flex px-3 gap-3" style={{width: '100%'}} ref={ref} onClick={onClick}>
      <Form.Check checked={checked} onChange={() => {}}/>
      {name}
    </div>
  )
})

export default function HideColumnButton({columns, setHiddenColumns, show, setShow}){

  return (
    <Dropdown autoClose={'outside'} onToggle={() => setShow(prevState => !prevState)}>
      <Dropdown.Toggle as={CustomToggle}/>
      <Dropdown.Menu show={show} style={{zIndex: 100, width: 'max-content'}} align={'start'}>
        {columns.map(column => <Dropdown.Item as={CustomItem} checked={!column.hidden} name={column.title} onClick={() => setHiddenColumns(column.title)}/>)}
      </Dropdown.Menu>
    </Dropdown>   
  )
}